import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-form-switch',
    template: `
        <p class="input-title" *ngIf="title">{{ title }}</p>
        <label class="switch-wrapper">{{ label }}
            <input type="checkbox"
                   [(ngModel)]="value"
                   [attr.checked]="value"
                   (blur)="onBlur()"
                   [disabled]="disabled">
            <span class="checkmark"></span>
        </label>
        <p class="input-error" *ngIf="error">{{ error }}</p>
    `,
    styleUrls: ['./form-switch.template.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormSwitchComponent),
            multi: true
        }
    ]
})
export class FormSwitchComponent implements ControlValueAccessor {
    @Input() title: string;
    @Input() label: string;
    @Input() disabled: boolean = false;
    @Input() placeholder: string = '';
    @Input() error: string = '';
    @Input() rows = 3;
    @Input('value') _value = '';
    @Output('value') valueEvent: EventEmitter<boolean> = new EventEmitter();

    onChange: any = () => {
    };
    onTouched: any = () => {
    };

    get value() {
        return this._value;
    }

    set value(val: any) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
        this.valueEvent.emit(val);
    }

    constructor() {
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {

        this.onTouched = fn;
    }

    writeValue(value: any) {
        if (value) {
            this.value = value;
        }
    }

    onBlur() {
        this.onTouched();
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/inputs/form-switch.component.ts